import { validateForm } from '../utils';
import useUser from '../../../user';
import { getFormValues, getStepFieldValue } from '../utils';
import { useSelector } from 'react-redux';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../../../firebase';

const useLoginLink = () => {
  const { sendLoginLink, accountExistsWithEmail } = useUser();
  const { dataLinks } = useSelector(state => state.DataLinks);

  const user = useSelector(state => state.User);
  const [firebaseUser] = useAuthState(auth);

  const issueLoginLink = async ({
    step,
    history,
    documents,
    selections,
    local,
    data,
    params
  }) => {
    let payload = {
      loginLinkRedirectBackTo: step.loginLinkRedirectBackTo
    };

    if (step.formId) {
      if (!validateForm({ formId: step.formId })) {
        return { error: 'invalid form values' };
      }

      payload = {
        ...payload,
        ...getFormValues({ formId: step.formId, returnObject: true })
      };
    }

    step.fields
      ?.filter(f => f.value.toString().indexOf('{data.') === -1)
      .forEach(stepField => {
        const fieldValue = getStepFieldValue({
          stepField,
          underlyingField: {
            type: stepField.fieldType
          },
          selections,
          history,
          documents,
          local,
          user,
          data,
          firebaseUser,
          dataLinks,
          params
        });

        // make sure text fields are no co-erced to numbers if the contain number strings
        if (stepField?.type === 'string' && fieldValue?.toString) {
          payload.email = fieldValue.toString();
        } else {
          payload.email = fieldValue;
        }
      });

    if (
      !payload.email ||
      payload.email?.indexOf('{') > -1 ||
      payload.email?.indexOf('}') > -1
    ) {
      if (user?.email) {
        payload.email = user?.email;
      } else if (firebaseUser?.email) {
        payload.email = firebaseUser.email;
      }
    }

    if (!payload.email) {
      return {
        error:
          'no email was supplied to the step. Verify there is a current user or supply a step field'
      };
    }

    // the user should always be logged out when we send a password link
    let accountExists =
      (user.validUser && user.uid !== undefined) ||
      history?.userRegistration?.result?.userID !== undefined;

    if (!accountExists) {
      accountExists = await accountExistsWithEmail(payload.email);
    } else {
      payload.email = user.email || history?.userRegistration?.result?.email;
    }

    if (accountExists.error || accountExists === undefined) {
      return {
        error:
          'Sorry. Due to a technical issue we cannot send your link at this time.',
        noAccountWithEmail: true
      };
    }

    let redirectUri = payload.loginLinkRedirectBackTo;
    if (process.env.REACT_APP_PASSWORDLESS_REDIRECT_HOST) {
      redirectUri = `${process.env.REACT_APP_PASSWORDLESS_REDIRECT_HOST}${redirectUri}`;
    } else if (process.env.PASSWORDLESS_REDIRECT_HOST) {
      redirectUri = `${process.env.PASSWORDLESS_REDIRECT_HOST}${redirectUri}`;
    } else {
      redirectUri = `${window.location.protocol}//${window.location.host}${payload.loginLinkRedirectBackTo}`;
    }

    if (accountExists) {
      return await sendLoginLink(payload.email, redirectUri);
    } else {
      return {
        error: 'no account found with specified email address',
        noAccountWithEmail: true
      };
    }
  };

  return {
    issueLoginLink
  };
};

export default useLoginLink;
